import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FooterBlockComponent } from "./FooterBlock";
import { defaultData } from "./FooterBlockDefaultData";

export const FooterBlock: BlockExport = {
  type: "component",
  Block: FooterBlockComponent,
  defaultData,
  meta: {
    name: "Footer",
    version: 1,
    isHidden: true,
  },
};
